import { useEffect, useState } from 'react';
import { mediaUrl } from '../lib/api';

type Props = {
  imageUrl: string | null;
  proxyUrl: string | null;
  alt: string;
  className?: string;
};

/**
 * Сначала пробуем картинку с сайта магазина напрямую — это быстрее.
 * Если магазин её не отдаёт (hotlink protection), переключаемся на наш прокси.
 */
export function ProductImage({ imageUrl, proxyUrl, alt, className = '' }: Props) {
  // Картинка, загруженная с устройства, приходит относительным путём нашего
  // сервера — его нужно так же дополнить базой, как и путь прокси.
  const primary = imageUrl?.startsWith('/') ? mediaUrl(imageUrl) : imageUrl;
  const chain = [primary, mediaUrl(proxyUrl)].filter(Boolean) as string[];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [imageUrl, proxyUrl]);

  const src = chain[index];

  if (!src) {
    return (
      <div className={`product-image product-image--empty ${className}`} aria-label={alt}>
        <span>нет фото</span>
      </div>
    );
  }

  return (
    <img
      className={`product-image ${className}`}
      src={src}
      alt={alt}
      loading="lazy"
      draggable={false}
      onError={() => setIndex((i) => i + 1)}
    />
  );
}
